export const BaseWeightOptions = [
  { value: 0, text: 'User Defined' },
  { value: 1, text: '100 Grams' },
];

export const SortByOptions = [
  { value: 'CN_Code', text: 'CN Code' },
  { value: 'Description', text: 'Description' },
];

export const INITIAL_SEARCH_PARAMETERS = {
  Search: '',
  ShowInvLinked: false,
  ShowInactive: false,
  UsedOnCycleMenu: false,
  TotalPages: 0,
};



// WEBPACK FOOTER //
// ./src/pages/ingredientlisting/helpers/Constants.js